module.exports = __webpack_public_path__ + "static/pauloakenfold_1-b9b1fd50b5bf70bbc2d030f2600264f9.jpg";